import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="controller-name"
export default class extends Controller {
  connect() {
  }
}
